// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sP-z","videoWrapper":"tP-z","twoColumnImage":"uP-z","imageCarouselBtn":"vP-z","carouselNextBtn":"wP-z","carouselPrevBtn":"xP-z"};